import {
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
} from "@mui/material"
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord"

// Define the pricing plan type

// Create the pricing plans data
const pricingPlans = [
  {
    title: "GOLD",
    headerColor: "#FDB515", // Dark blue
    features: [
      "20+ hours of one-on-one admissions coaching (based on grade level)",
      "Essay editing for 6 college applications and personal statement",
      "Personal Admissions Expert with 2+ years of experience",
    ],
    buttonText: "Schedule Free Consultation",
  },
  {
    title: "PLATINUM",
    headerColor: "#4D7CFE", // Light blue
    features: [
      "30+ hours of one-on-one admissions coaching (based on grade level)",
      "Essay editing for 9 college applications and personal statement",
      "Personal Admissions Expert with 2+ years of experience",
      "Former College Admissions Officer",
    ],
    buttonText: "Schedule Free Consultation",
  },
  {
    title: "DIAMOND",
    headerColor: "#003262", // Green
    features: [
      "40+ hours of one-on-one admissions coaching (based on grade level)",
      "Essay editing for 12 college applications and personal statement",
      "Personal Admissions Expert with 2+ years of experience",
      "Former College Admissions Officer",
    ],
    buttonText: "Schedule Free Consultation",
  },
]

export default function Subscription() {
  const onClickScheduleFreeConsultation = () => {
    window.open("https://calendly.com/dreamcollegepath/30min", "_blank");    
  }
  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 2, mt: 2 }}>
        <Typography
          variant="h3"
          component="h3"
          sx={{
            fontSize: { xs: "1rem", md: "2rem" },
            fontWeight: "bold",
            color: "#222",
            // mb: 1,
          }}
        >
          Subscription Plans
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: { xs: "0.8rem", md: "1rem" },
            color: "#666",
            maxWidth: "90%",
          }}
        >
          Comprehensive and personalized packages to guide you and your family through every aspect of your college
          admissions process.
        </Typography>
      </Box>
      <Box sx={{ overflowX: "auto", py: 4 }}>
        <Box sx={{ display: "flex", minWidth: "min-content", }}>
          {pricingPlans.map((plan, index) => (
            <Box
              key={index}
              sx={{
                width: 320,
                minWidth: 320,
                px: 1.5,
              }}
            >
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                  overflow: "hidden",
                }}
              >
                <CardHeader
                  title={
                    <Typography variant="h5" component="div" align="center" fontWeight="bold" sx={{ color: "#fff" }}>
                      {plan.title}
                    </Typography>
                  }
                  sx={{
                    backgroundColor: plan.headerColor,
                    py: 2,
                  }}
                />
                <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                  <Box sx={{ mb: 2 }}>
                    <List>
                      {plan.features.map((feature, featureIndex) => (
                        <ListItem className="list-item-marker" key={featureIndex} alignItems="flex-start" sx={{ py: 1 }}>
                          <ListItemIcon sx={{ minWidth: 24, mt: 1.5 }}>
                            <FiberManualRecordIcon sx={{ fontSize: 8 }} />
                          </ListItemIcon>
                          <ListItemText primary={feature} />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                  <Box sx={{ mt: "auto", display: "flex", justifyContent: "center" }}>
                    <Button
                      variant="outlined"
                      sx={{
                        borderRadius: 50,
                        px: 3,
                        py: 1,
                        textTransform: "none",
                        borderColor: "#000",
                        color: "#000",
                        "&:hover": {
                          borderColor: plan.headerColor,
                          color: plan.headerColor,
                        },
                      }}
                      onClick={onClickScheduleFreeConsultation}
                    >
                      {plan.buttonText}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  )
}